export interface LabDayTilesCopy {
    formats: { day: string; time: string; timeWithMinutes: string } | null
    maxDays: number | null
    moreAction: string
}

export interface LabSearchCopy {
    heading: string
    showBookingDisclaimer: boolean
    dayTiles: LabDayTilesCopy
}

export interface LabPlanVisitCopy {
    heading: string
    rescheduleHeading: string
    continueLabel: string
    deferBooking: boolean
}

export interface LabConditionsCopy {
    heading: string
    body: string
    continueLabel: string
    cashActionLabel: string
    insuranceActionLabel: string
    videoVisitActionLabel: string
}

export interface LabBillingCopy {
    heading: string
    continueLabel: string
}

export interface LabCheckoutCopy {
    heading: string
    bookAction: string
}

export interface LabsCopy {
    search: LabSearchCopy
    planVisit: LabPlanVisitCopy
    conditions: LabConditionsCopy
    billing: LabBillingCopy
    checkout: LabCheckoutCopy
}

export const generalMedicineLabsCopy: LabsCopy = {
    search: {
        heading: 'Choose lab',
        showBookingDisclaimer: true,
        dayTiles: {
            formats: null,
            maxDays: null,
            moreAction: 'More appts',
        },
    },
    planVisit: {
        heading: 'Plan your visit',
        rescheduleHeading: 'Reschedule labs',
        continueLabel: 'Continue',
        deferBooking: false,
    },
    conditions: {
        heading: 'Do you have any of the following health conditions?',
        body: 'Please select all conditions that apply to you. This helps us provide the best possible care for your needs.',
        continueLabel: 'Continue',
        cashActionLabel: 'Continue without insurance',
        insuranceActionLabel: 'Continue with insurance anyway',
        videoVisitActionLabel: 'Book a video visit',
    },
    billing: {
        heading: 'Lab billing method',
        continueLabel: 'Continue',
    },
    checkout: {
        heading: 'Confirm & pay',
        bookAction: 'Book labs',
    },
}
